import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { recordContactCardOpen } from '../api/contactCardOpenApi';

/**
 * Reports a contact-card open when the page was reached from a shared card.
 *
 * The `share` parameter carries the delivery id, which both links in the card
 * email append. Mount this on every page those links can land on — the profile
 * and the signup page — so the funnel measures "did they come back" and not only
 * "did they sign up". Someone who clicks through to read the provider's profile
 * and never creates an account is still a card that worked.
 *
 * Reports once per delivery id per mounted page: React runs effects twice in
 * development, and a visitor moving between the profile and signup should not
 * count as two arrivals from the same link.
 */
export function useContactCardOpen(): void {
  const [searchParams] = useSearchParams();
  const deliveryId = searchParams.get('share');
  const reported = useRef(new Set<string>());

  useEffect(() => {
    if (!deliveryId || reported.current.has(deliveryId)) return;
    reported.current.add(deliveryId);
    void recordContactCardOpen(deliveryId);
  }, [deliveryId]);
}
